// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  min-height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px;
  background: #f5f7fa;
}

.profile-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 48px;
  max-width: 800px;
  width: 100%;
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.profile-header {
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
}

.profile-header h1 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.profile-header p {
  color: #666;
  margin: 0;
  font-size: 15px;
}

.profile-section {
  margin-bottom: 24px;
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.profile-section-toggle {
  width: 100%;
  border: 0;
  background: #fbfbfc;
  padding: 14px 16px;
  cursor: pointer;
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 10px;
  text-align: left;
  font-family: inherit;
}

.profile-section-title {
  font-weight: 700;
  color: #333;
}

.profile-section-hint {
  font-size: 13px;
  color: #666;
}

.profile-section-caret {
  font-size: 16px;
  color: #666;
}

.profile-section-content {
  border-top: 2px solid #f0f0f0;
  background: #fff;
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transform: translateY(-2px);
  transition: grid-template-rows 260ms cubic-bezier(0.2, 0.8, 0.2, 1),
    opacity 180ms ease,
    transform 220ms ease;
  will-change: grid-template-rows, opacity, transform;
}

.profile-section-content-inner {
  padding: 16px;
  overflow: hidden;
}

.profile-section-content.open {
  grid-template-rows: 1fr;
  opacity: 1;
  transform: translateY(0);
}

.profile-section-content.closed {
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .profile-card,
  .alert,
  .profile-section-content {
    animation: none !important;
    transition: none !important;
  }
}

.loading-state {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.alert {
  padding: 16px 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group textarea,
.form-group select {
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.2s;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group input:disabled,
.form-group textarea:disabled,
.form-group select:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

.avatar-preview {
  margin-top: 12px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e0e0e0;
}

.avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  padding-top: 24px;
  border-top: 2px solid #f0f0f0;
}

.submit-button,
.cancel-button {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.submit-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.submit-button:active:not(:disabled) {
  transform: translateY(0);
}

.submit-button:disabled,
.cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-button.loading {
  position: relative;
  color: transparent;
}

.submit-button.loading::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  left: 50%;
  margin-left: -10px;
  margin-top: -10px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.cancel-button {
  background: #f5f5f5;
  color: #666;
}

.cancel-button:hover:not(:disabled) {
  background: #e0e0e0;
}

@media (max-width: 768px) {
  .profile-container {
    padding: 20px 16px;
  }

  .profile-card {
    padding: 32px 24px;
  }

  .profile-header h1 {
    font-size: 28px;
  }

  .form-actions {
    flex-direction: column;
  }

  .submit-button,
  .cancel-button {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Profile.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,2BAA2B;EAC3B;;wBAEsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".profile-container {\n  min-height: calc(100vh - 80px);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 40px 20px;\n  background: #f5f7fa;\n}\n\n.profile-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 48px;\n  max-width: 800px;\n  width: 100%;\n  animation: slideUp 0.4s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.profile-header {\n  text-align: center;\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.profile-header h1 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 32px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.profile-header p {\n  color: #666;\n  margin: 0;\n  font-size: 15px;\n}\n\n.profile-section {\n  margin-bottom: 24px;\n  border: 2px solid #f0f0f0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.profile-section-toggle {\n  width: 100%;\n  border: 0;\n  background: #fbfbfc;\n  padding: 14px 16px;\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n  font-family: inherit;\n}\n\n.profile-section-title {\n  font-weight: 700;\n  color: #333;\n}\n\n.profile-section-hint {\n  font-size: 13px;\n  color: #666;\n}\n\n.profile-section-caret {\n  font-size: 16px;\n  color: #666;\n}\n\n.profile-section-content {\n  border-top: 2px solid #f0f0f0;\n  background: #fff;\n  display: grid;\n  grid-template-rows: 0fr;\n  opacity: 0;\n  transform: translateY(-2px);\n  transition: grid-template-rows 260ms cubic-bezier(0.2, 0.8, 0.2, 1),\n    opacity 180ms ease,\n    transform 220ms ease;\n  will-change: grid-template-rows, opacity, transform;\n}\n\n.profile-section-content-inner {\n  padding: 16px;\n  overflow: hidden;\n}\n\n.profile-section-content.open {\n  grid-template-rows: 1fr;\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.profile-section-content.closed {\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .profile-card,\n  .alert,\n  .profile-section-content {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n.loading-state {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n.alert {\n  padding: 16px 20px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.alert-success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.alert-error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.alert svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.profile-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 15px;\n  transition: all 0.2s;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group input:disabled,\n.form-group textarea:disabled,\n.form-group select:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.avatar-preview {\n  margin-top: 12px;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid #e0e0e0;\n}\n\n.avatar-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.char-count {\n  text-align: right;\n  font-size: 12px;\n  color: #999;\n  margin-top: 4px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  padding-top: 24px;\n  border-top: 2px solid #f0f0f0;\n}\n\n.submit-button,\n.cancel-button {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  padding: 14px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.submit-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);\n}\n\n.submit-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submit-button:disabled,\n.cancel-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.submit-button.loading {\n  position: relative;\n  color: transparent;\n}\n\n.submit-button.loading::after {\n  content: '';\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  top: 50%;\n  left: 50%;\n  margin-left: -10px;\n  margin-top: -10px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.cancel-button {\n  background: #f5f5f5;\n  color: #666;\n}\n\n.cancel-button:hover:not(:disabled) {\n  background: #e0e0e0;\n}\n\n@media (max-width: 768px) {\n  .profile-container {\n    padding: 20px 16px;\n  }\n\n  .profile-card {\n    padding: 32px 24px;\n  }\n\n  .profile-header h1 {\n    font-size: 28px;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .submit-button,\n  .cancel-button {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
